<template>
  <div class="dialog-root">
    <div class="container">
      <el-form ref="formRef" :model="formData" label-width="130px">
        <el-row>
          <el-col span="12">
            <el-form-item label="电表表号：">
              <el-input v-model="rowData.code" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="上期止码：">
              <el-input v-model="rowData.lastEndNum" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              prop="unitPrice"
              label="单价："
              :rules="[{ required: true, message: '请输入单价', trigger: 'blur' }]"
            >
              <moneyInput
                v-model="formData.unitPrice"
                placeholder="请输入 单价"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              prop="endNum"
              label="本期止码："
              :rules="[{ required: true, message: '请输入本期止码', trigger: 'blur' }]"
            >
              <moneyInput
                v-model="formData.endNum"
                placeholder="请输入 本期止码"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="当前余额：">
              <el-input v-model="rowData.balance" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="扣缴金额：">
              <el-input v-model="reduceAmount" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              prop="chargeOrReadTime"
              label="抄表时间："
              :rules="[{ required: true, message: '请输入抄表时间', trigger: 'blur' }]"
            >
              <el-date-picker
                v-model="formData.chargeOrReadTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 按钮占位区域 -->
    <div class="placeholder"></div>
    <!-- 底部操作按钮 -->
    <div class="btn">
      <el-button type="primary" size="small" @click="doSave">修改</el-button>
      <el-button size="small" @click="doClose">取消</el-button>
    </div>
  </div>
</template>

<script>
import { withholdApi } from '@/api/electric-meter/electric-meter-management';

export default {
  props: ['rowData'],
  data() {
    return {
      // 表单数据
      formData: {
        unitPrice: 0,
        endNum: 0,
        reduceAmount: 0,
        chargeOrReadTime: '',
      },
    };
  },
  computed: {
    reduceAmount() {
      if (
        this.formData.unitPrice &&
        this.formData.endNum &&
        typeof this.formData.endNum == 'number' &&
        typeof this.formData.unitPrice == 'number'
      ) {
        return (
          this.formData.unitPrice *
          (this.formData.endNum - parseFloat(this.rowData.lastEndNum))
        ).toFixed(2);
      }
    },
  },
  created() {
    this.formData = Object.assign(
      {},
      {
        id: this.rowData.id,
        unitPrice: parseFloat(this.rowData.unitPrice),
        chargeOrReadTime: this.dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
      }
    );
  },
  methods: {
    /* 保存 */
    doSave() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          if (this.formData.endNum <= parseFloat(this.rowData.lastEndNum)) {
            this.$message.error('本期止码须大于上期止码');
            return;
          }
          if (this.reduceAmount > parseFloat(this.rowData.balance)) {
            this.$message.error('扣缴金额须小于等于当前余额');
            return;
          }
          this.formData.reduceAmount = this.reduceAmount;
          withholdApi(this.formData, {
            showLoading: { text: '处理中...' },
          }).then(() => {
            this.$message.success('操作成功!');
            this.$emit('update');
          });
        }
      });
    },
    /* 取消 */
    doClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-root {
  /* 给按钮的父元素加一个相对定位，方便按钮的布局 */
  position: relative;
  /* 内容容器 */
  .container {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    max-height: 60vh;
    padding: 0 10px;
    overflow: scroll;
  }
  /* 按钮占位区域 */
  .placeholder {
    height: 50px;
  }
  /* 底部固定的按钮区域 */
  .btn {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #fff;
  }
}
</style>
